import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordWarningTriangleIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 9v4m0 4h.01M10.29 3.86L2.82 18c-.18.3-.22.65-.11.98.11.33.36.6.68.74.32.14.68.18 1.02.09.34-.09.63-.3.82-.6l7.47-14.14c-.18-.3-.43-.55-.73-.71-.3-.16-.65-.2-.98-.12-.33.08-.62.29-.82.59M10.29 3.86L17.76 18c.19.3.48.51.82.6.34.09.7.05 1.02-.09.32-.14.57-.41.68-.74.11-.33.07-.68-.11-.98l-7.47-14.14c-.2-.3-.49-.51-.82-.59-.33-.08-.68-.04-.98.12-.3.16-.55.41-.73.71"
      />
    </svg>
  );
};

export default BordWarningTriangleIcon;